export default __webpack_public_path__ + "3b6a6ba.png";